/* Machino fulfillment guard v2 (store-stock flow, Sep 2026)
   Reads per-variant states from script[data-machino-fulfillment-map] JSON.
   States: ships (default) | pickup_only | sold_out. na:1 = natively unavailable (theme handles).
   v2 default: pickup_only sizes look sold out online. Store stock lives in the
   "Check store stock" panel; SS18 sizes with no online stock get "Reserve for pickup".
   Works on Broadcast 4 (data-single-option-selector) and Broadcast 8 (variant-selects).
   Pickup service detection (merged from the 18 Sep 2026 live v1 patch): probes the
   api-pickup-availability section once per page. If local pickup is disabled in Shopify
   (no pickup__preview in the response), Reserve buttons are hidden, pickup_only variants
   are treated as sold_out, the store panel goes view-only, and the cart banner/chips/
   checkout relabel are suppressed. Probe failure = assume pickup is on. */
(function () {
  'use strict';

  /* The script tag is emitted by both the product form snippet and the cart drawer snippet,
     so it can load twice on one page. Register handlers once. */
  if (window.__machinoFulfillmentLoaded) return;
  window.__machinoFulfillmentLoaded = true;

  var registry = {};
  var lastState = {};
  var timers = {};
  var PICKUP_STORE = 'Machino SS18, Subang Jaya';
  var isV8 = function () { return !!document.querySelector('variant-selects, cart-items, cart-drawer'); };

  /* null = unknown (assume on), true = pickup service on, false = off */
  var pickupEnabled = null;
  var probeStarted = false;

  function probePickup(variantId) {
    if (probeStarted || !variantId) return;
    probeStarted = true;
    var root = (window.theme && window.theme.routes && window.theme.routes.root)
      || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      || '/';
    if (root.slice(-1) !== '/') root += '/';
    fetch(root + 'variants/' + variantId + '/?section_id=api-pickup-availability')
      .then(function (r) {
        if (!r.ok) throw new Error('probe failed');
        return r.text();
      })
      .then(function (html) {
        pickupEnabled = html.indexOf('pickup__preview') !== -1;
        Object.keys(registry).forEach(schedule);
        applyCart();
        applyStorePanels();
      })
      .catch(function () { /* leave pickupEnabled = null: fail toward pickup on */ });
  }

  /* Pickup off: hide every Reserve button and make the SS18 block read like the
     view-only outlets. One-way per page (pickupEnabled never flips back), so the
     writes only need to be idempotent, not reversible. */
  function applyStorePanels() {
    if (pickupEnabled !== false) return;
    var reserves = document.querySelectorAll('[data-mfp-reserve]');
    for (var i = 0; i < reserves.length; i++) {
      if (reserves[i].style.display !== 'none') reserves[i].style.display = 'none';
    }
    var badges = document.querySelectorAll('.mfp-store__badge--pickup');
    for (var j = 0; j < badges.length; j++) {
      var badge = badges[j];
      setText(badge, 'Visit store');
      var loc = badge.closest('.mfp-store__loc');
      var foot = loc && loc.querySelector('.mfp-store__foot');
      setText(foot, 'Shown for reference. This outlet does not take online orders, so please visit in person.');
      badge.classList.remove('mfp-store__badge--pickup');
    }
  }

  function collectMaps(root) {
    var scripts = (root || document).querySelectorAll('script[data-machino-fulfillment-map]');
    for (var i = 0; i < scripts.length; i++) {
      var el = scripts[i];
      var formId = el.getAttribute('data-mfp-form');
      if (!formId) continue;
      /* Broadcast 8's quick-add modal gives every product the same form id, so a form is
         re-registered whenever its map text changes, not just the first time it is seen. */
      if (registry[formId] && registry[formId].raw === el.textContent) continue;
      try {
        var data = JSON.parse(el.textContent);
        data.raw = el.textContent;
        data.firstShip = null;
        for (var j = 0; j < data.variants.length; j++) {
          var v = data.variants[j];
          if (v.s === 'ships' && !v.na) { data.firstShip = v; break; }
        }
        registry[formId] = data;
        delete lastState[formId];
        for (var k = 0; k < data.variants.length; k++) {
          if (data.variants[k].s === 'pickup_only') { probePickup(data.variants[k].id); break; }
        }
        initForm(formId);
      } catch (e) { /* malformed map: fail safe, do nothing */ }
    }
  }

  function optionInputs(formId) {
    var v4 = document.querySelectorAll('[data-single-option-selector][form="' + formId + '"]');
    if (v4.length) return v4;
    return document.querySelectorAll('variant-selects input[type="radio"][form="' + formId + '"]');
  }

  function mfpInputIndex(input) {
    var di = input.getAttribute('data-index');
    if (di) return parseInt(di.replace('option', ''), 10) - 1;
    var wrap = input.closest ? input.closest('[data-option-position]') : null;
    if (wrap) return parseInt(wrap.getAttribute('data-option-position'), 10) - 1;
    return -1;
  }

  function selectedOptions(formId) {
    var inputs = optionInputs(formId), values = [];
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var idx = mfpInputIndex(input);
      if (isNaN(idx) || idx < 0) continue;
      if (input.type === 'radio') { if (input.checked) values[idx] = input.value; }
      else values[idx] = input.value;
    }
    return values;
  }

  function matchVariant(data, values) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], match = true;
      for (var j = 0; j < v.o.length; j++) {
        if (values[j] !== v.o[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function findVariant(formId) {
    var data = registry[formId];
    if (!data) return null;
    if (data.singleDefault) return data.variants[0] || null;
    var byOptions = matchVariant(data, selectedOptions(formId));
    if (byOptions) return byOptions;
    var form = document.getElementById(formId);
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(idInput.value)) return data.variants[i];
      }
    }
    return null;
  }

  /* v2: pickup-only pills get the theme's own sold-out look plus a small amber dot */
  function markPills(formId) {
    var data = registry[formId];
    if (!data || data.singleDefault) return;
    var inputs = optionInputs(formId);
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.type !== 'radio') continue;
      var idx = mfpInputIndex(input);
      if (isNaN(idx) || idx < 0) continue;
      var values = selectedOptions(formId).slice();
      values[idx] = input.value;
      var v = matchVariant(data, values);
      var wrap = input.closest('.radio__button');
      var isPickup = !!v && v.s === 'pickup_only' && !v.na;
      if (wrap) wrap.classList.toggle('mfp-pill-pickup', isPickup && pickupEnabled !== false);
      if (v && !v.na && (v.s === 'sold_out' || v.s === 'pickup_only')) input.classList.add('mfp-offline');
    }
  }

  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }

  function apply(formId) {
    var data = registry[formId];
    if (!data) return;
    var form = document.getElementById(formId);
    if (!form) return;
    var btn = form.querySelector('[data-add-to-cart]');
    var txt = form.querySelector('[data-add-to-cart-text]');
    var notice = document.querySelector('[data-mfp-notice][data-mfp-form="' + formId + '"]');
    var store = document.querySelector('[data-mfp-store][data-mfp-form="' + formId + '"]');
    var variant = findVariant(formId);
    var state = variant ? (variant.na ? 'native_sold' : variant.s) : 'ships';

    /* Pickup service off: pickup-only stock cannot be fulfilled at all */
    if (state === 'pickup_only' && pickupEnabled === false) state = 'sold_out';

    if (state === 'pickup_only') {
      if (btn && txt) {
        btn.classList.remove('mfp-btn-pickup');
        btn.setAttribute('disabled', 'disabled');
        setText(txt, 'Sold out online');
      }
      if (notice) {
        var lead = notice.querySelector('[data-mfp-lead]');
        setText(lead, data.singleDefault ? 'This item is' : 'Size ' + variant.o.join(' / ') + ' is');
        var swap = notice.querySelector('[data-mfp-swap]');
        if (swap) swap.hidden = !data.firstShip;
        var open = notice.querySelector('[data-mfp-open-store]');
        if (open) open.hidden = !store || !store.offsetParent;
        notice.hidden = false;
      }
    } else {
      if (notice) notice.hidden = true;
      if (btn && txt) {
        btn.classList.remove('mfp-btn-pickup');
        if (state === 'sold_out') {
          btn.setAttribute('disabled', 'disabled');
          setText(txt, 'Sold out');
        } else if (state === 'ships' && (lastState[formId] === 'pickup_only' || lastState[formId] === 'sold_out')) {
          btn.removeAttribute('disabled');
          setText(txt, data.atc || 'Add to cart');
        }
      }
    }
    lastState[formId] = state;
    markPills(formId);
  }

  function schedule(formId) {
    clearTimeout(timers[formId]);
    timers[formId] = setTimeout(function () { apply(formId); }, 30);
  }

  function swapToShip(formId) {
    var data = registry[formId];
    if (!data || !data.firstShip) return;
    var target = data.firstShip;
    var inputs = optionInputs(formId);
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var idx = mfpInputIndex(input);
      if (isNaN(idx) || idx < 0 || idx >= target.o.length) continue;
      if (input.type === 'radio') {
        if (input.value === target.o[idx] && !input.checked) {
          if (typeof input.click === 'function') {
            input.click();
          } else {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } else if (input.value !== target.o[idx]) {
        input.value = target.o[idx];
        var popout = input.closest('[data-popout]');
        var toggleText = popout && popout.querySelector('[data-popout-toggle-text]');
        if (toggleText) toggleText.textContent = target.o[idx];
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    schedule(formId);
  }

  function initForm(formId) {
    var data = registry[formId];
    var explicitVariant = /[?&]variant=/.test(location.search);
    var v = findVariant(formId);
    if (!explicitVariant && !data.singleDefault && v && !v.na && v.s !== 'ships' && data.firstShip) {
      var run = function () { swapToShip(formId); };
      if (document.querySelector('variant-selects') && window.customElements && customElements.whenDefined) {
        /* Broadcast 8: wait for the theme's variant component so the hidden id follows the pill */
        customElements.whenDefined('variant-selects').then(function () { setTimeout(run, 60); });
        setTimeout(run, 1200);
      } else {
        run();
      }
    } else {
      schedule(formId);
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.getAttribute) return;
    var formId = t.getAttribute('form');
    if (formId && registry[formId]) {
      schedule(formId);
      setTimeout(function () { apply(formId); }, 350);
    }
  });

  ['theme:variant:change', 'variant:change'].forEach(function (name) {
    document.addEventListener(name, function () {
      Object.keys(registry).forEach(schedule);
    });
  });
  if (typeof window.subscribe === 'function' && window.theme && theme.PUB_SUB_EVENTS && theme.PUB_SUB_EVENTS.variantChange) {
    try {
      subscribe(theme.PUB_SUB_EVENTS.variantChange, function () {
        Object.keys(registry).forEach(schedule);
        setTimeout(function () { Object.keys(registry).forEach(apply); }, 150);
      });
    } catch (e) { /* older theme without pub/sub */ }
  }

  /* ---------- store stock panel ---------- */
  function storeFor(formId) { return document.querySelector('[data-mfp-store][data-mfp-form="' + formId + '"]'); }

  function setPanel(store, open) {
    if (!store) return;
    var panel = store.querySelector('[data-mfp-store-panel]');
    var toggle = store.querySelector('[data-mfp-store-toggle]');
    if (panel) panel.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    store.classList.toggle('is-open', !!open);
  }

  function flashPills(formId) {
    var inputs = optionInputs(formId);
    for (var i = 0; i < inputs.length; i++) {
      var wrap = inputs[i].closest('.radio__button');
      if (wrap && !wrap.classList.contains('mfp-pill-pickup') && !inputs[i].classList.contains('mfp-offline')) {
        wrap.classList.remove('mfp-flash');
        void wrap.offsetWidth;
        wrap.classList.add('mfp-flash');
      }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var swap = t.closest('[data-mfp-swap]');
    if (swap) {
      e.preventDefault();
      var fid = swap.getAttribute('data-mfp-form');
      if (fid && registry[fid]) { swapToShip(fid); flashPills(fid); }
      return;
    }

    var toggle = t.closest('[data-mfp-store-toggle]');
    if (toggle) {
      e.preventDefault();
      var st = toggle.closest('[data-mfp-store]');
      var panel = st && st.querySelector('[data-mfp-store-panel]');
      setPanel(st, panel ? panel.hidden : true);
      return;
    }

    var openStore = t.closest('[data-mfp-open-store]');
    if (openStore) {
      e.preventDefault();
      var st2 = storeFor(openStore.getAttribute('data-mfp-form'));
      setPanel(st2, true);
      if (st2 && st2.scrollIntoView) st2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var reserve = t.closest('[data-mfp-reserve]');
    if (reserve) {
      e.preventDefault();
      startReserve(reserve);
      return;
    }
  });

  /* ---------- reserve for pickup ---------- */
  function cartHasDeliveryItems(cb) {
    fetch((window.theme && theme.routes && theme.routes.root ? theme.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return cb(false);
        /* The cart drawer markup is server-rendered with the pickup banner; use it as the source of truth. */
        var banner = document.querySelector('[data-mfp-cart-banner]');
        var allPickup = !!banner && banner.getAttribute('data-mfp-all-pickup') === 'true';
        if (allPickup) return cb(false);
        /* Fallback: every line we reserved carries the Collect at property. */
        for (var i = 0; i < cart.items.length; i++) {
          var p = cart.items[i].properties || {};
          if (!p['Collect at']) return cb(true);
        }
        cb(false);
      })
      .catch(function () { cb(false); });
  }

  function ensureModal() {
    var m = document.getElementById('mfp-confirm');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'mfp-confirm';
    m.className = 'mfp-confirm';
    m.hidden = true;
    m.innerHTML =
      '<div class="mfp-confirm__box" role="dialog" aria-modal="true" aria-labelledby="mfp-confirm-title">' +
        '<h3 id="mfp-confirm-title">You have delivery items in your cart</h3>' +
        '<p>Store pickup and home delivery can\'t be combined in one order. Check out your delivery items first, then come back and reserve <span data-mfp-confirm-size></span> for pickup. Or add it now and collect the whole order at ' + PICKUP_STORE + '.</p>' +
        '<div class="mfp-confirm__btns">' +
          '<button type="button" class="mfp-confirm__no" data-mfp-confirm-no>Not now</button>' +
          '<button type="button" class="mfp-confirm__yes" data-mfp-confirm-yes>Add anyway</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !m.hidden) { m.hidden = true; m._onYes = null; }
    });
    m.addEventListener('click', function (e) {
      if (e.target === m || e.target.closest('[data-mfp-confirm-no]')) { m.hidden = true; m._onYes = null; }
      else if (e.target.closest('[data-mfp-confirm-yes]')) { m.hidden = true; var fn = m._onYes; m._onYes = null; if (fn) fn(); }
    });
    return m;
  }

  function reserveMessage(btn, text) {
    /* one message line per outlet block, shown under the size chips */
    var loc = btn.closest('.mfp-store__loc') || btn.parentNode;
    var msg = loc.querySelector('.mfp-store__msg');
    if (!text) { if (msg) msg.hidden = true; return; }
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'mfp-store__msg';
      var sizes = loc.querySelector('.mfp-store__sizes');
      if (sizes && sizes.parentNode) sizes.parentNode.insertBefore(msg, sizes.nextSibling); else loc.appendChild(msg);
    }
    msg.textContent = text;
    msg.hidden = false;
  }

  function cartCount(cb) {
    fetch((window.theme && theme.routes && theme.routes.root ? theme.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cb(c && typeof c.item_count === 'number' ? c.item_count : -1); })
      .catch(function () { cb(-1); });
  }

  function startReserve(btn) {
    if (pickupEnabled === false) return; /* button should already be hidden; belt and braces */
    if (btn.classList.contains('is-busy')) return;
    var variantId = btn.getAttribute('data-mfp-reserve');
    var title = btn.getAttribute('data-mfp-title') || '';
    reserveMessage(btn, '');
    btn.classList.add('is-busy');
    cartHasDeliveryItems(function (mixed) {
      if (!mixed) { btn.classList.remove('is-busy'); return addReserve(btn, variantId); }
      var m = ensureModal();
      var sz = m.querySelector('[data-mfp-confirm-size]');
      if (sz) sz.textContent = title ? 'size ' + title : 'this item';
      m._onYes = function () { addReserve(btn, variantId); };
      m.hidden = false;
      btn.classList.remove('is-busy');
    });
  }

  var RESERVE_FAIL = 'This size could not be reserved. It may have just sold out in store, or it is already in your cart.';

  function addReserve(btn, variantId) {
    var props = { 'Collect at': PICKUP_STORE };
    var title = btn.getAttribute('data-mfp-title') || '';
    btn.classList.add('is-busy');
    var done = function () { btn.classList.remove('is-busy'); };
    if (!isV8()) {
      /* Broadcast 4: the theme's cart class listens for this event, posts to cart/add.js and opens the drawer.
         It reports failures only inside the (closed) drawer, so compare the cart count before and after. */
      cartCount(function (before) {
        document.dispatchEvent(new CustomEvent('theme:cart:add', {
          bubbles: true,
          detail: { selector: btn, element: null, label: null, button: null, data: { id: parseInt(variantId, 10), quantity: 1, properties: props } }
        }));
        setTimeout(function () {
          cartCount(function (after) {
            done();
            if (before >= 0 && after >= 0 && after <= before) reserveMessage(btn, (title ? 'Size ' + title + ': ' : '') + RESERVE_FAIL);
          });
        }, 1500);
      });
      return;
    }
    /* Broadcast 8: post ourselves, then ask the theme to refresh the drawer (which also opens it) */
    var url = (window.theme && theme.routes && theme.routes.cart_add_url) ? theme.routes.cart_add_url : '/cart/add.js';
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: props }] })
    }).then(function (r) {
      return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) { /* not JSON */ } return { ok: r.ok, j: j }; });
    }).then(function (out) {
      done();
      var j = out.j;
      /* Shopify answers a rejected add with 422 and either {status, message, description} or {errors: "..."} */
      if (!out.ok || !j || j.status || j.errors) {
        var why = j && (j.description || j.message || (typeof j.errors === 'string' ? j.errors : null));
        reserveMessage(btn, (title ? 'Size ' + title + ': ' : '') + (why || RESERVE_FAIL));
        return;
      }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      var drawer = document.querySelector('cart-drawer');
      if (drawer) setTimeout(function () { drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true })); }, 400);
    }).catch(done);
  }

  /* ---------- cart: relabel checkout button when the whole order is store pickup ----------
     IMPORTANT: writes are guarded on inequality. An unconditional write re-triggers
     the MutationObserver and livelocks the page. */
  function labelNode(el) {
    /* the text node that carries the visible label, so icons/spans around it survive a relabel */
    var best = null;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) { if (n.nodeValue.trim()) best = n; }
    return best;
  }

  function setLabel(el, label) {
    var isInput = el.tagName === 'INPUT';
    var current = isInput ? el.value : el.textContent.trim();
    if (current === label) return;
    if (isInput) { el.value = label; return; }
    var node = labelNode(el);
    if (node) {
      /* blank any other text nodes so the old label cannot linger beside the new one */
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = walker.nextNode())) { if (t !== node && t.nodeValue.trim()) t.nodeValue = ' '; }
      node.nodeValue = ' ' + label + ' ';
    } else {
      el.textContent = label;
    }
  }

  var CART_CHECKOUT = '[data-cart-drawer] button[name="checkout"], [data-cart-drawer] input[name="checkout"], cart-drawer button[name="checkout"], cart-drawer input[name="checkout"], .cart__checkout, form[action$="/cart"] button[name="checkout"], form[action$="/cart"] input[name="checkout"]';

  /* A pickup-only line in the cart: on Broadcast 4 its variant id comes from the remove
     link's data-id (line_item.key = "<variant_id>:<hash>"); anywhere else fall back to
     cart.js, because the probe only needs some valid variant id to render the section. */
  function cartProbeVariant() {
    var chip = document.querySelector('.mfp-chip');
    var item = chip && chip.closest('[data-item]');
    var remove = item && item.querySelector('[data-item-remove]');
    var key = remove && remove.getAttribute('data-id');
    var vid = key && key.split(':')[0];
    return (vid && /^\d+$/.test(vid)) ? vid : null;
  }

  var cartProbeAsked = false;
  function probeFromCart() {
    if (probeStarted || cartProbeAsked) return;
    var vid = cartProbeVariant();
    if (vid) { probePickup(vid); return; }
    cartProbeAsked = true;
    fetch((window.theme && theme.routes && theme.routes.root ? theme.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = cart && cart.items && cart.items[0];
        if (it && it.variant_id) probePickup(String(it.variant_id));
      })
      .catch(function () { /* probe stays unstarted: assume pickup on */ });
  }

  function applyCart() {
    var banner = document.querySelector('[data-mfp-cart-banner]');
    if (banner && !probeStarted) probeFromCart();

    var off = pickupEnabled === false;
    if (banner && (banner.style.display === 'none') !== off) {
      banner.style.display = off ? 'none' : '';
    }
    var chips = document.querySelectorAll('.mfp-chip');
    for (var c = 0; c < chips.length; c++) {
      if ((chips[c].style.display === 'none') !== off) {
        chips[c].style.display = off ? 'none' : '';
      }
    }

    var allPickup = !off && !!banner && banner.getAttribute('data-mfp-all-pickup') === 'true';
    var buttons = document.querySelectorAll(CART_CHECKOUT);
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var isInput = b.tagName === 'INPUT';
      var current = isInput ? b.value : b.textContent.trim();
      if (!b.hasAttribute('data-mfp-orig') && current !== 'Checkout for store pickup') {
        b.setAttribute('data-mfp-orig', current);
      }
      if (allPickup) {
        setLabel(b, 'Checkout for store pickup');
      } else if (current === 'Checkout for store pickup') {
        setLabel(b, b.getAttribute('data-mfp-orig') || 'Checkout');
      }
    }
  }

  var moScheduled = false;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        if (moScheduled) return;
        moScheduled = true;
        setTimeout(function () {
          moScheduled = false;
          collectMaps(document);
          applyCart();
          applyStorePanels();
          Object.keys(registry).forEach(schedule);
        }, 50);
        return;
      }
    }
  });

  function boot() {
    collectMaps(document);
    applyCart();
    if (!probeStarted) {
      var rb = document.querySelector('[data-mfp-reserve]');
      if (rb) probePickup(rb.getAttribute('data-mfp-reserve'));
    }
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
